/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { ACMIRequestBuilderRequestsMetadata, type ACMIRequestBuilder } from './aCMI/index.js';
// @ts-ignore
import { AircraftTypeRequestBuilderNavigationMetadata, AircraftTypeRequestBuilderRequestsMetadata, type AircraftTypeRequestBuilder } from './aircraftType/index.js';
// @ts-ignore
import { AllotmentRequestBuilderNavigationMetadata, AllotmentRequestBuilderRequestsMetadata, type AllotmentRequestBuilder } from './allotment/index.js';
// @ts-ignore
import { AllotmentEvolutionRequestBuilderNavigationMetadata, AllotmentEvolutionRequestBuilderRequestsMetadata, type AllotmentEvolutionRequestBuilder } from './allotmentEvolution/index.js';
// @ts-ignore
import { AllotmentReportRequestBuilderNavigationMetadata, type AllotmentReportRequestBuilder } from './allotmentReport/index.js';
// @ts-ignore
import { AllotmentRoleRequestBuilderRequestsMetadata, type AllotmentRoleRequestBuilder } from './allotmentRole/index.js';
// @ts-ignore
import { AllotmentUpgradeRequestBuilderNavigationMetadata, AllotmentUpgradeRequestBuilderRequestsMetadata, type AllotmentUpgradeRequestBuilder } from './allotmentUpgrade/index.js';
// @ts-ignore
import { AmadeusEngineRequestBuilderRequestsMetadata, type AmadeusEngineRequestBuilder } from './amadeusEngine/index.js';
// @ts-ignore
import { AuditLogRequestBuilderNavigationMetadata, AuditLogRequestBuilderRequestsMetadata, type AuditLogRequestBuilder } from './auditLog/index.js';
// @ts-ignore
import { BookingRequestBuilderNavigationMetadata, type BookingRequestBuilder } from './booking/index.js';
// @ts-ignore
import { BrandingRequestBuilderNavigationMetadata, BrandingRequestBuilderRequestsMetadata, type BrandingRequestBuilder } from './branding/index.js';
// @ts-ignore
import { BusinessRuleRequestBuilderNavigationMetadata, BusinessRuleRequestBuilderRequestsMetadata, type BusinessRuleRequestBuilder } from './businessRule/index.js';
// @ts-ignore
import { ChangesRequestBuilderNavigationMetadata, ChangesRequestBuilderRequestsMetadata, type ChangesRequestBuilder } from './changes/index.js';
// @ts-ignore
import { CharterRequestBuilderNavigationMetadata, CharterRequestBuilderRequestsMetadata, type CharterRequestBuilder } from './charter/index.js';
// @ts-ignore
import { CharterAuditLogRequestBuilderNavigationMetadata, CharterAuditLogRequestBuilderRequestsMetadata, type CharterAuditLogRequestBuilder } from './charterAuditLog/index.js';
// @ts-ignore
import { CharterRoleRequestBuilderRequestsMetadata, type CharterRoleRequestBuilder } from './charterRole/index.js';
// @ts-ignore
import { ClientRequestBuilderNavigationMetadata, ClientRequestBuilderRequestsMetadata, type ClientRequestBuilder } from './client/index.js';
// @ts-ignore
import { ClientACMIRequestBuilderRequestsMetadata, type ClientACMIRequestBuilder } from './clientACMI/index.js';
// @ts-ignore
import { DashboardRequestBuilderNavigationMetadata, type DashboardRequestBuilder } from './dashboard/index.js';
// @ts-ignore
import { FareRequestBuilderNavigationMetadata, FareRequestBuilderRequestsMetadata, type FareRequestBuilder } from './fare/index.js';
// @ts-ignore
import { FareBasisCodeRequestBuilderNavigationMetadata, FareBasisCodeRequestBuilderRequestsMetadata, type FareBasisCodeRequestBuilder } from './fareBasisCode/index.js';
// @ts-ignore
import { FareCalcTaxBreakdownsRequestBuilderRequestsMetadata, type FareCalcTaxBreakdownsRequestBuilder } from './fareCalcTaxBreakdowns/index.js';
// @ts-ignore
import { FinancialReportRequestBuilderNavigationMetadata, FinancialReportRequestBuilderRequestsMetadata, type FinancialReportRequestBuilder } from './financialReport/index.js';
// @ts-ignore
import { FlightNumberRequestBuilderNavigationMetadata, FlightNumberRequestBuilderRequestsMetadata, type FlightNumberRequestBuilder } from './flightNumber/index.js';
// @ts-ignore
import { IataRequestBuilderRequestsMetadata, type IataRequestBuilder } from './iata/index.js';
// @ts-ignore
import { InvoiceRequestBuilderNavigationMetadata, InvoiceRequestBuilderRequestsMetadata, type InvoiceRequestBuilder } from './invoice/index.js';
// @ts-ignore
import { MasterRuleRequestBuilderRequestsMetadata, type MasterRuleRequestBuilder } from './masterRule/index.js';
// @ts-ignore
import { OperatingAirlineRequestBuilderNavigationMetadata, OperatingAirlineRequestBuilderRequestsMetadata, type OperatingAirlineRequestBuilder } from './operatingAirline/index.js';
// @ts-ignore
import { OpsHubRequestBuilderRequestsMetadata, type OpsHubRequestBuilder } from './opsHub/index.js';
// @ts-ignore
import { PassengerDataFileRequestBuilderNavigationMetadata, PassengerDataFileRequestBuilderRequestsMetadata, type PassengerDataFileRequestBuilder } from './passengerDataFile/index.js';
// @ts-ignore
import { PoolingFlightRequestBuilderNavigationMetadata, PoolingFlightRequestBuilderRequestsMetadata, type PoolingFlightRequestBuilder } from './poolingFlight/index.js';
// @ts-ignore
import { PoolingHistoryRequestBuilderNavigationMetadata, PoolingHistoryRequestBuilderRequestsMetadata, type PoolingHistoryRequestBuilder } from './poolingHistory/index.js';
// @ts-ignore
import { RevVardocRequestBuilderNavigationMetadata, RevVardocRequestBuilderRequestsMetadata, type RevVardocRequestBuilder } from './revVardoc/index.js';
// @ts-ignore
import { ScheduleRequestBuilderRequestsMetadata, type ScheduleRequestBuilder } from './schedule/index.js';
// @ts-ignore
import { SeasonRequestBuilderNavigationMetadata, SeasonRequestBuilderRequestsMetadata, type SeasonRequestBuilder } from './season/index.js';
// @ts-ignore
import { StagingAllotmentRequestBuilderNavigationMetadata, StagingAllotmentRequestBuilderRequestsMetadata, type StagingAllotmentRequestBuilder } from './stagingAllotment/index.js';
// @ts-ignore
import { StagingFareRequestBuilderNavigationMetadata, StagingFareRequestBuilderRequestsMetadata, type StagingFareRequestBuilder } from './stagingFare/index.js';
// @ts-ignore
import { StagingPassengerDataRequestBuilderNavigationMetadata, StagingPassengerDataRequestBuilderRequestsMetadata, type StagingPassengerDataRequestBuilder } from './stagingPassengerData/index.js';
// @ts-ignore
import { TaskRequestBuilderNavigationMetadata, type TaskRequestBuilder } from './task/index.js';
// @ts-ignore
import { TourOperatorRequestBuilderNavigationMetadata, TourOperatorRequestBuilderRequestsMetadata, type TourOperatorRequestBuilder } from './tourOperator/index.js';
// @ts-ignore
import { TourOperatorRoleRequestBuilderRequestsMetadata, type TourOperatorRoleRequestBuilder } from './tourOperatorRole/index.js';
// @ts-ignore
import { type UserRequestBuilder, UserRequestBuilderNavigationMetadata, UserRequestBuilderRequestsMetadata } from './user/index.js';
// @ts-ignore
import { apiClientProxifier, ParseNodeFactoryRegistry, SerializationWriterFactoryRegistry, type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type RequestAdapter } from '@microsoft/kiota-abstractions';
// @ts-ignore
import { FormParseNodeFactory, FormSerializationWriterFactory } from '@microsoft/kiota-serialization-form';
// @ts-ignore
import { JsonParseNodeFactory, JsonSerializationWriterFactory } from '@microsoft/kiota-serialization-json';
// @ts-ignore
import { MultipartSerializationWriterFactory } from '@microsoft/kiota-serialization-multipart';
// @ts-ignore
import { TextParseNodeFactory, TextSerializationWriterFactory } from '@microsoft/kiota-serialization-text';

/**
 * The main entry point of the SDK, exposes the configuration and the fluent API.
 */
export interface ApiClient extends BaseRequestBuilder<ApiClient> {
    /**
     * The ACMI property
     */
    get aCMI(): ACMIRequestBuilder;
    /**
     * The AircraftType property
     */
    get aircraftType(): AircraftTypeRequestBuilder;
    /**
     * The Allotment property
     */
    get allotment(): AllotmentRequestBuilder;
    /**
     * The AllotmentEvolution property
     */
    get allotmentEvolution(): AllotmentEvolutionRequestBuilder;
    /**
     * The AllotmentReport property
     */
    get allotmentReport(): AllotmentReportRequestBuilder;
    /**
     * The AllotmentRole property
     */
    get allotmentRole(): AllotmentRoleRequestBuilder;
    /**
     * The AllotmentUpgrade property
     */
    get allotmentUpgrade(): AllotmentUpgradeRequestBuilder;
    /**
     * The AmadeusEngine property
     */
    get amadeusEngine(): AmadeusEngineRequestBuilder;
    /**
     * The AuditLog property
     */
    get auditLog(): AuditLogRequestBuilder;
    /**
     * The Booking property
     */
    get booking(): BookingRequestBuilder;
    /**
     * The Branding property
     */
    get branding(): BrandingRequestBuilder;
    /**
     * The BusinessRule property
     */
    get businessRule(): BusinessRuleRequestBuilder;
    /**
     * The Changes property
     */
    get changes(): ChangesRequestBuilder;
    /**
     * The Charter property
     */
    get charter(): CharterRequestBuilder;
    /**
     * The CharterAuditLog property
     */
    get charterAuditLog(): CharterAuditLogRequestBuilder;
    /**
     * The CharterRole property
     */
    get charterRole(): CharterRoleRequestBuilder;
    /**
     * The Client property
     */
    get client(): ClientRequestBuilder;
    /**
     * The ClientACMI property
     */
    get clientACMI(): ClientACMIRequestBuilder;
    /**
     * The Dashboard property
     */
    get dashboard(): DashboardRequestBuilder;
    /**
     * The Fare property
     */
    get fare(): FareRequestBuilder;
    /**
     * The FareBasisCode property
     */
    get fareBasisCode(): FareBasisCodeRequestBuilder;
    /**
     * The FareCalcTaxBreakdowns property
     */
    get fareCalcTaxBreakdowns(): FareCalcTaxBreakdownsRequestBuilder;
    /**
     * The FinancialReport property
     */
    get financialReport(): FinancialReportRequestBuilder;
    /**
     * The FlightNumber property
     */
    get flightNumber(): FlightNumberRequestBuilder;
    /**
     * The Iata property
     */
    get iata(): IataRequestBuilder;
    /**
     * The Invoice property
     */
    get invoice(): InvoiceRequestBuilder;
    /**
     * The MasterRule property
     */
    get masterRule(): MasterRuleRequestBuilder;
    /**
     * The OperatingAirline property
     */
    get operatingAirline(): OperatingAirlineRequestBuilder;
    /**
     * The OpsHub property
     */
    get opsHub(): OpsHubRequestBuilder;
    /**
     * The PassengerDataFile property
     */
    get passengerDataFile(): PassengerDataFileRequestBuilder;
    /**
     * The PoolingFlight property
     */
    get poolingFlight(): PoolingFlightRequestBuilder;
    /**
     * The PoolingHistory property
     */
    get poolingHistory(): PoolingHistoryRequestBuilder;
    /**
     * The RevVardoc property
     */
    get revVardoc(): RevVardocRequestBuilder;
    /**
     * The Schedule property
     */
    get schedule(): ScheduleRequestBuilder;
    /**
     * The Season property
     */
    get season(): SeasonRequestBuilder;
    /**
     * The StagingAllotment property
     */
    get stagingAllotment(): StagingAllotmentRequestBuilder;
    /**
     * The StagingFare property
     */
    get stagingFare(): StagingFareRequestBuilder;
    /**
     * The StagingPassengerData property
     */
    get stagingPassengerData(): StagingPassengerDataRequestBuilder;
    /**
     * The Task property
     */
    get task(): TaskRequestBuilder;
    /**
     * The TourOperator property
     */
    get tourOperator(): TourOperatorRequestBuilder;
    /**
     * The TourOperatorRole property
     */
    get tourOperatorRole(): TourOperatorRoleRequestBuilder;
    /**
     * The User property
     */
    get user(): UserRequestBuilder;
}
/**
 * Instantiates a new {@link ApiClient} and sets the default values.
 * @param requestAdapter The request adapter to use to execute the requests.
 */
// @ts-ignore
export function createApiClient(requestAdapter: RequestAdapter) {
    if (requestAdapter === undefined) {
        throw new Error("requestAdapter cannot be undefined");
    }
    const serializationWriterFactory = requestAdapter.getSerializationWriterFactory() as SerializationWriterFactoryRegistry;
    const parseNodeFactoryRegistry = requestAdapter.getParseNodeFactory() as ParseNodeFactoryRegistry;
    const backingStoreFactory = requestAdapter.getBackingStoreFactory();
    
    if (parseNodeFactoryRegistry.registerDefaultDeserializer) {
        parseNodeFactoryRegistry.registerDefaultDeserializer(JsonParseNodeFactory, backingStoreFactory);
        parseNodeFactoryRegistry.registerDefaultDeserializer(TextParseNodeFactory, backingStoreFactory);
        parseNodeFactoryRegistry.registerDefaultDeserializer(FormParseNodeFactory, backingStoreFactory);
    }
    
    if (serializationWriterFactory.registerDefaultSerializer) {
        serializationWriterFactory.registerDefaultSerializer(JsonSerializationWriterFactory);
        serializationWriterFactory.registerDefaultSerializer(TextSerializationWriterFactory);
        serializationWriterFactory.registerDefaultSerializer(FormSerializationWriterFactory);
        serializationWriterFactory.registerDefaultSerializer(MultipartSerializationWriterFactory);
    }
    
    if (requestAdapter.baseUrl === undefined || requestAdapter.baseUrl === null || requestAdapter.baseUrl === "") {
        requestAdapter.baseUrl = "https://localhost/WBS_Allotment";
    }
    const pathParameters: Record<string, unknown> = {
        "baseurl": requestAdapter.baseUrl,
    };
    return apiClientProxifier<ApiClient>(requestAdapter, pathParameters, ApiClientNavigationMetadata, undefined);
}
/**
 * Uri template for the request builder.
 */
export const ApiClientUriTemplate = "{+baseurl}";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const ApiClientNavigationMetadata: Record<Exclude<keyof ApiClient, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    aCMI: {
        requestsMetadata: ACMIRequestBuilderRequestsMetadata,
    },
    aircraftType: {
        requestsMetadata: AircraftTypeRequestBuilderRequestsMetadata,
        navigationMetadata: AircraftTypeRequestBuilderNavigationMetadata,
    },
    allotment: {
        requestsMetadata: AllotmentRequestBuilderRequestsMetadata,
        navigationMetadata: AllotmentRequestBuilderNavigationMetadata,
    },
    allotmentEvolution: {
        requestsMetadata: AllotmentEvolutionRequestBuilderRequestsMetadata,
        navigationMetadata: AllotmentEvolutionRequestBuilderNavigationMetadata,
    },
    allotmentReport: {
        navigationMetadata: AllotmentReportRequestBuilderNavigationMetadata,
    },
    allotmentRole: {
        requestsMetadata: AllotmentRoleRequestBuilderRequestsMetadata,
    },
    allotmentUpgrade: {
        requestsMetadata: AllotmentUpgradeRequestBuilderRequestsMetadata,
        navigationMetadata: AllotmentUpgradeRequestBuilderNavigationMetadata,
    },
    amadeusEngine: {
        requestsMetadata: AmadeusEngineRequestBuilderRequestsMetadata,
    },
    auditLog: {
        requestsMetadata: AuditLogRequestBuilderRequestsMetadata,
        navigationMetadata: AuditLogRequestBuilderNavigationMetadata,
    },
    booking: {
        navigationMetadata: BookingRequestBuilderNavigationMetadata,
    },
    branding: {
        requestsMetadata: BrandingRequestBuilderRequestsMetadata,
        navigationMetadata: BrandingRequestBuilderNavigationMetadata,
    },
    businessRule: {
        requestsMetadata: BusinessRuleRequestBuilderRequestsMetadata,
        navigationMetadata: BusinessRuleRequestBuilderNavigationMetadata,
    },
    changes: {
        requestsMetadata: ChangesRequestBuilderRequestsMetadata,
        navigationMetadata: ChangesRequestBuilderNavigationMetadata,
    },
    charter: {
        requestsMetadata: CharterRequestBuilderRequestsMetadata,
        navigationMetadata: CharterRequestBuilderNavigationMetadata,
    },
    charterAuditLog: {
        requestsMetadata: CharterAuditLogRequestBuilderRequestsMetadata,
        navigationMetadata: CharterAuditLogRequestBuilderNavigationMetadata,
    },
    charterRole: {
        requestsMetadata: CharterRoleRequestBuilderRequestsMetadata,
    },
    client: {
        requestsMetadata: ClientRequestBuilderRequestsMetadata,
        navigationMetadata: ClientRequestBuilderNavigationMetadata,
    },
    clientACMI: {
        requestsMetadata: ClientACMIRequestBuilderRequestsMetadata,
    },
    dashboard: {
        navigationMetadata: DashboardRequestBuilderNavigationMetadata,
    },
    fare: {
        requestsMetadata: FareRequestBuilderRequestsMetadata,
        navigationMetadata: FareRequestBuilderNavigationMetadata,
    },
    fareBasisCode: {
        requestsMetadata: FareBasisCodeRequestBuilderRequestsMetadata,
        navigationMetadata: FareBasisCodeRequestBuilderNavigationMetadata,
    },
    fareCalcTaxBreakdowns: {
        requestsMetadata: FareCalcTaxBreakdownsRequestBuilderRequestsMetadata,
    },
    financialReport: {
        requestsMetadata: FinancialReportRequestBuilderRequestsMetadata,
        navigationMetadata: FinancialReportRequestBuilderNavigationMetadata,
    },
    flightNumber: {
        requestsMetadata: FlightNumberRequestBuilderRequestsMetadata,
        navigationMetadata: FlightNumberRequestBuilderNavigationMetadata,
    },
    iata: {
        requestsMetadata: IataRequestBuilderRequestsMetadata,
    },
    invoice: {
        requestsMetadata: InvoiceRequestBuilderRequestsMetadata,
        navigationMetadata: InvoiceRequestBuilderNavigationMetadata,
    },
    masterRule: {
        requestsMetadata: MasterRuleRequestBuilderRequestsMetadata,
    },
    operatingAirline: {
        requestsMetadata: OperatingAirlineRequestBuilderRequestsMetadata,
        navigationMetadata: OperatingAirlineRequestBuilderNavigationMetadata,
    },
    opsHub: {
        requestsMetadata: OpsHubRequestBuilderRequestsMetadata,
    },
    passengerDataFile: {
        requestsMetadata: PassengerDataFileRequestBuilderRequestsMetadata,
        navigationMetadata: PassengerDataFileRequestBuilderNavigationMetadata,
    },
    poolingFlight: {
        requestsMetadata: PoolingFlightRequestBuilderRequestsMetadata,
        navigationMetadata: PoolingFlightRequestBuilderNavigationMetadata,
    },
    poolingHistory: {
        requestsMetadata: PoolingHistoryRequestBuilderRequestsMetadata,
        navigationMetadata: PoolingHistoryRequestBuilderNavigationMetadata,
    },
    revVardoc: {
        requestsMetadata: RevVardocRequestBuilderRequestsMetadata,
        navigationMetadata: RevVardocRequestBuilderNavigationMetadata,
    },
    schedule: {
        requestsMetadata: ScheduleRequestBuilderRequestsMetadata,
    },
    season: {
        requestsMetadata: SeasonRequestBuilderRequestsMetadata,
        navigationMetadata: SeasonRequestBuilderNavigationMetadata,
    },
    stagingAllotment: {
        requestsMetadata: StagingAllotmentRequestBuilderRequestsMetadata,
        navigationMetadata: StagingAllotmentRequestBuilderNavigationMetadata,
    },
    stagingFare: {
        requestsMetadata: StagingFareRequestBuilderRequestsMetadata,
        navigationMetadata: StagingFareRequestBuilderNavigationMetadata,
    },
    stagingPassengerData: {
        requestsMetadata: StagingPassengerDataRequestBuilderRequestsMetadata,
        navigationMetadata: StagingPassengerDataRequestBuilderNavigationMetadata,
    },
    task: {
        navigationMetadata: TaskRequestBuilderNavigationMetadata,
    },
    tourOperator: {
        requestsMetadata: TourOperatorRequestBuilderRequestsMetadata,
        navigationMetadata: TourOperatorRequestBuilderNavigationMetadata,
    },
    tourOperatorRole: {
        requestsMetadata: TourOperatorRoleRequestBuilderRequestsMetadata,
    },
    user: {
        requestsMetadata: UserRequestBuilderRequestsMetadata,
        navigationMetadata: UserRequestBuilderNavigationMetadata,
    },
};
/* tslint:enable */
/* eslint-enable */
